import React, { memo, useEffect, useState } from "react";
import { Handle, Position } from "@xyflow/react";
import { MDBAutocomplete, MDBBtn, MDBIcon, MDBSpinner } from "mdb-react-ui-kit";
import { getMisc } from "../../apiclients/streamsapi_bridge";
import CFNodeUI from "./NodeUI";
import { customSearch } from "../CustomSearchUtil/CustomSearch";
export default memo(({ data, isConnectable }) => {
  const [isloading, setIsloading] = useState(true);
 
  function onDelete(id) {
    data.onDelete(id);
  }
  const [callerList, setCallerList] = useState([]);
  const [defaultData, setDefaultData] = useState([]);
  const [displayValuess, setDisplayValuess] = useState([]);
  const [selected, setSelected] = useState(
    data.selected_object ? data.selected_object.label : ""
  );

  useEffect(()=>{
    setSelected(data.selected_object ? data.selected_object.label : "")
    fetchAAMiscData();
  },[data]);
  const [customData, setCustomData] = useState(displayValuess);
  async function fetchAAMiscData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["voicemails"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    console.log( "table data :::::: " , JSON.stringify(tdata));
    if (!tdata) {
      window.alert(`info with id  not found`);
    }

    const userList = tdata?.misc?.voicemails?.users ?? [];
    const groupList = (tdata?.misc?.voicemails?.groups || []);
    const voicemails = tdata?.misc?.voicemails?.voicemails ?? [];
    const callerlists = tdata?.misc?.voicemails?.cid_pass ?? [];

    const mergeWithSortList = [...userList, ...groupList, ...voicemails].sort(
      (a, b) => a?.title?.localeCompare(b?.title)
    );
    mergeWithSortList.unshift({ _id: -1, title: "Create a Voicemail Box" })
    console.log(userList);
    console.log(mergeWithSortList);
    setDefaultData(mergeWithSortList);
    // setDisplayValuess([
    //   { _id: -1, title: "Create a Voicemail Box" },
    //   ...mergeWithSortList,
    // ]);
    setDisplayValuess(mergeWithSortList);
    setCustomData(displayValuess)
    console.log( "displayValuess:::::::::::::::::::::::::::::::::::"   , displayValuess)
    setDisplayValuess(mergeWithSortList);
    setCallerList(callerlists);
    setIsloading(false);
  }

  useEffect(() => {
    fetchAAMiscData();
  }, []);
  
const onCustomSearch = (value) =>
    setCustomData(
      customSearch(displayValuess, value, ['title', 'extension'])
          );
  const openLocation = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(
      "selectedItem",
      data.selected_object ? data.selected_object.label : ""
    );
    window.open("/userlanding");
  };

  const handleFocus = (event) => {
    if (event.target.value != "") {
      event.target.select();
      setCustomData(displayValuess);
    }
  };
  return (
    <>
      <CFNodeUI
        headerClass="yellowNodeHeader"
        data={data}
        deletable={true}
        onDelete={onDelete}
        isConnectable={isConnectable}
        bodyContnent={
          <>
            <div className="nodeSelectLinkIcon">
              <MDBAutocomplete
                data={customData}
                displayValue={(item) => {
                  const categoryPart = item.category
                    ? ` : ${item.category}`
                    : "";
                  const extensionpart = item.extension
                    ? `  ${item.extension} :`
                    : "";
                  return `${extensionpart} ${item.title}${categoryPart}`;
                }}
                placeholder={"Choose Voicemail Box"}
                value={selected}
                title={selected}
                onClick={handleFocus}
                onChange={(val) => setSelected(val)}
                onSelect={(e) =>
                  (function processClick(value) {
                    if (value === " Create a Voicemail Box") {
                      data.actionExecutor({ action: 1 });
                    } else {
                      let selectedObj = customData.filter((selectedObj) =>
                        value.includes(selectedObj.extension)
                      );

                      data.selected_object = {
                        label: value,
                        ...selectedObj[0],
                        code: selectedObj[0]?.uniqueId ?? "",
                      };
                      data.actionExecutor({
                        action: 2,
                        value: selectedObj[0] || -1,
                      });
                    }
                  })(e)
                }
                onSearch={onCustomSearch}
                
              />

              {/* {data.selected_object && (
                <>
                  <MDBIcon
                    fas
                    icon="external-link-square-alt"
                    className="nodeLinkIcon"
                    onClick={(e) => openLocation(e)}
                  />
                </>
              )} */}
            </div>
          </>
        }
        targetNode={true}
      />
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
});
